"use client";

import { useMotionValue, useSpring, motion } from "framer-motion";
import { useEffect } from "react";

export const Cursor = () => {
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);

  const springConfig = { damping: 25, stiffness: 100 };
  const cursorXSpring = useSpring(cursorX, springConfig);
  const cursorYSpring = useSpring(cursorY, springConfig);

  useEffect(() => {
    const moveCursor = (e) => {
      requestAnimationFrame(() => {
        // Update position only on animation frame
        cursorX.set(e.clientX - 12); // Adjust offset for center alignment
        cursorY.set(e.clientY - 12); // Adjust offset for center alignment
      });
    };

    window.addEventListener("mousemove", moveCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
    };
  }, [cursorX, cursorY]);

  return (
    <motion.div
      className="fixed top-0 left-0 bg-white mix-blend-difference z-50 rounded-full pointer-events-none grid place-items-center max-md:hidden"
      style={{
        translateX: cursorXSpring,
        translateY: cursorYSpring,
        width: 20,
        height: 20,
        backgroundColor: "transparent",
        border: "2px solid white",
        boxShadow: "0 0 15px rgba(255, 255, 255, 0.8)",
      }}
      whileHover={{
        scale: 1.5,
        transition: { duration: 0.2 },
      }}
    />
  );
};
